import React, { useEffect, useState } from 'react';
import Project from '../../common/Utils/project';
import { useAuth } from 'oidc-react';
import { usePatchForm } from '../../providers/PatchFormProvider';
import { useTenantSelection } from '../../providers/TenantSelectionProvider';
import api from '../../components/services/apiService';

const ApproverModal = ({ onClose, onDone }) => {
  const { selectedTenantId } = useTenantSelection();
  const auth = useAuth();
  const { patchFormData, setPatchFormData } = usePatchForm();
  const [approvers, setApprovers] = useState([]);
  const getApprover = async () => {
    try {
      if (auth && auth.userData) {
        const token = auth.userData.access_token;
        let tenantId = selectedTenantId;
        let roleName = 'Approver';
        const response = await api.get(`${Project.api}tenantservice/TenantGroup/${tenantId}/users/${roleName}`);
        let { data } = response;
        setApprovers(data.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    getApprover();
  }, []);
  const handleApprover = (tenantUserId) => {
    setPatchFormData((prev) => ({
      ...prev,
      ...{
        RemediationPlanUserList: [
          {
            TenantUserID: tenantUserId,
            DefatomUserRole: 1,
          },
        ],
      },
    }));
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-[#1e1e1e] text-white rounded-lg p-6 w-full shadow-lg" style={{ maxWidth: '60%' }}>
        <label className="block text-sm mb-2">Select Approver</label>
        <select
          className="w-full bg-[#2a2a2a] text-white p-3 rounded-md border border-gray-600 appearance-none"
          onChange={(e) => handleApprover(e.target.value)}
        >
          <option>Select Approver</option>
          {approvers?.map((item) => (
            <option key={item.tenantUserId} value={item.tenantUserId}>
              {`${item.firstName} ${item.lastName}`}
            </option>
          ))}
        </select>

        <div className="flex justify-end mt-6 space-x-4">
          <button onClick={onClose} className="px-6 py-2 rounded-full border border-gray-400 hover:bg-gray-700">
            Cancel
          </button>
          <button onClick={onDone} className="px-6 py-2 rounded-full bg-red-600 hover:bg-red-700">
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApproverModal;
